(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["djzone-compare"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.getElementById('dz-compare-result');
    if (!root) return;
    var KEY = 'dz-compare-v1';
    var loadingEl = document.getElementById('dz-compare-loading');
    var emptyEl = document.getElementById('dz-compare-empty');
    var tableEl = document.getElementById('dz-compare-table');
    var phone = window.matchMedia('(max-width: 749px)');
    var shown = null;

    function stored() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function wanted() {
      var shared = new URLSearchParams(location.search).get('p');
      if (shared) return shared.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 4);
      return stored().map(function (entry) { return entry.handle; }).slice(0, 4);
    }
    function price(cents) {
      return '₪' + (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    function tidy(text) { return String(text || '').replace(/\s+/g, ' ').trim(); }

    function plainText(html) {
      var holder = document.createElement('div');
      holder.innerHTML = String(html || '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
        .replace(/<[^>]+>/g, ' ');
      return holder.textContent.replace(/[ \t]+/g, ' ');
    }

    /* Descriptions arrived from OpenCart in three shapes: a dz-specs table,
       a bullet list, or running prose. The table wins, the "key: value" lines
       come next, and the patterns below pull the facts buyers actually compare
       out of whatever is left. */
    function tableSpecs(html) {
      var out = {};
      var holder = document.createElement('div');
      holder.innerHTML = html || '';
      holder.querySelectorAll('tr').forEach(function (row) {
        var cells = row.querySelectorAll('th, td');
        if (cells.length < 2) return;
        var key = tidy(cells[0].textContent);
        var value = tidy(cells[1].textContent);
        if (key && value && key.length <= 34) out[key] = value;
      });
      return out;
    }

    function lineSpecs(text) {
      var out = {};
      text.split('\n').forEach(function (line) {
        var parts = tidy(line).split(/\s*:\s*/);
        if (parts.length < 2) return;
        var key = parts.shift();
        var value = parts.join(': ');
        if (key.length >= 2 && key.length <= 24 && value && value.length <= 90) out[key] = value;
      });
      return out;
    }

    var WORDS = {
      'אחת': '1', 'אחד': '1', 'שתי': '2', 'שני': '2', 'שתיים': '2', 'שלוש': '3', 'שלושה': '3',
      'ארבע': '4', 'ארבעה': '4', 'חמש': '5', 'חמישה': '5', 'שש': '6', 'שישה': '6',
      'שבע': '7', 'שבעה': '7', 'שמונה': '8', 'תשע': '9', 'תשעה': '9', 'עשר': '10', 'עשרה': '10'
    };
    var NUM = '(\\d{1,3}|' + Object.keys(WORDS).join('|') + ')';
    function asNumber(token) { return WORDS[token] || token; }

    function counted(text, nounPattern, suffix) {
      var match = text.match(new RegExp(NUM + '\\s*' + nounPattern));
      return match ? asNumber(match[1]) + (suffix || '') : null;
    }

    var DERIVED = [
      { label: 'ערוצים', better: 'high', find: function (t) { return counted(t, '(?:ערוצים|ערוצי)'); } },
      { label: 'כניסות מיקרופון', better: 'high', find: function (t) { return counted(t, 'כניסות\\s*מיקרופון'); } },
      { label: 'הספק', better: 'high', find: function (t) {
          var m = t.match(/(\d[\d,.]*)\s*(?:W\b|וואט|ואט)/i);
          return m ? m[1].replace(/,/g, '') + ' ואט' : null;
        } },
      { label: 'גודל רמקול', better: 'high', find: function (t) {
          var m = t.match(/\b(6|8|10|12|15|18)\s*(?:["״”]|אינץ)/);
          return m ? m[1] + ' אינץ׳' : null;
        } },
      { label: 'משקל', better: 'low', find: function (t) {
          var m = t.match(/(\d+(?:\.\d+)?)\s*(?:ק"ג|ק״ג|קילו|kg)/i);
          return m ? m[1] + ' ק״ג' : null;
        } },
      { label: 'מידות', find: function (t) {
          var m = t.match(/(\d[\d.]*\s*[x×]\s*\d[\d.]*\s*[x×]\s*\d[\d.]*\s*(?:מ"מ|מ״מ|ס"מ|ס״מ|mm|cm))/i);
          return m ? tidy(m[1]) : null;
        } },
      { label: 'פאנטום 48V', find: function (t) { return /48\s*V|פאנטום/i.test(t) ? 'יש' : null; } },
      { label: 'כרטיס קול / USB', find: function (t) { return /USB|כרטיס קול/i.test(t) ? 'יש' : null; } },
      { label: 'אפקטים מובנים', find: function (t) {
          var m = t.match(/(\d{1,2})\s*אפקטים/);
          if (m) return m[1] + ' אפקטים';
          return /אפקטים מובנים|ריוורב|דיליי/.test(t) ? 'יש' : null;
        } },
      { label: 'איקולייזר', find: function (t) { return /איקולייזר|אקולייזר|\bEQ\b/i.test(t) ? 'יש' : null; } },
      { label: 'בלוטות׳', find: function (t) { return /בלוטות|bluetooth/i.test(t) ? 'יש' : null; } },
      { label: 'תוכנה בחבילה', find: function (t) {
          var found = (t.match(/rekordbox|serato(?: DJ Pro)?|cubase(?: LE)?|virtual ?dj|traktor/gi) || []);
          if (!found.length) return null;
          var unique = [];
          found.forEach(function (name) {
            var clean = tidy(name);
            if (!unique.some(function (u) { return u.toLowerCase() === clean.toLowerCase(); })) unique.push(clean);
          });
          return unique.slice(0, 3).join(', ');
        } }
    ];

    function specsOf(product) {
      var text = plainText(product.description);
      var out = tableSpecs(product.description);
      var lines = lineSpecs(text);
      Object.keys(lines).forEach(function (key) { if (!(key in out)) out[key] = lines[key]; });
      DERIVED.forEach(function (rule) {
        if (out[rule.label]) return;
        var value = rule.find(text);
        if (value) out[rule.label] = value;
      });
      return out;
    }

    function cell(text, extraClass) {
      var td = document.createElement('td');
      if (extraClass) td.className = extraClass;
      td.textContent = text;
      return td;
    }

    function remove(handle) {
      try {
        localStorage.setItem(KEY, JSON.stringify(stored().filter(function (e) { return e.handle !== handle; })));
      } catch (e) { /* storage blocked */ }
    }

    function render(products) {
      shown = products;
      var compact = phone.matches;
      tableEl.innerHTML = '';
      tableEl.classList.toggle('is-compact', compact);
      tableEl.style.setProperty('--dz-cols', String(products.length));

      var headRow = document.createElement('tr');
      if (!compact) headRow.appendChild(document.createElement('th'));
      products.forEach(function (product) {
        var td = document.createElement('td');
        td.className = 'dz-compare__head';

        var image = document.createElement('img');
        image.src = product.featured_image || (product.images && product.images[0]) || '';
        image.alt = product.title;

        var link = document.createElement('a');
        link.className = 'dz-compare__name';
        link.href = '/products/' + product.handle;
        link.textContent = product.title;

        var tag = document.createElement('span');
        tag.className = 'dz-compare__price';
        tag.textContent = product.available ? price(product.price) : 'אזל מהמלאי';

        var buy = document.createElement('a');
        buy.className = 'dz-action dz-action--small';
        buy.href = '/products/' + product.handle;
        buy.textContent = 'לעמוד המוצר';

        var drop = document.createElement('button');
        drop.type = 'button';
        drop.className = 'dz-compare__drop';
        drop.textContent = 'הסרה מההשוואה';
        drop.addEventListener('click', function () {
          remove(product.handle);
          var keep = products.filter(function (p) { return p.handle !== product.handle; });
          if (!keep.length) { shown = null; root.hidden = true; emptyEl.hidden = false; }
          else { render(keep); }
        });

        [image, link, tag, buy, drop].forEach(function (node) { td.appendChild(node); });
        headRow.appendChild(td);
      });
      tableEl.appendChild(headRow);

      var rows = [
        { label: 'מחיר', better: 'low', values: products.map(function (p) { return p.available ? price(p.price) : 'אזל מהמלאי'; }) },
        { label: 'יצרן', values: products.map(function (p) { return p.vendor || ''; }) },
        { label: 'קטגוריה', values: products.map(function (p) { return p.type || ''; }) },
        { label: 'זמינות', values: products.map(function (p) { return p.available ? 'במלאי' : 'אזל מהמלאי'; }) }
      ];

      var sets = products.map(specsOf);
      var keys = [];
      sets.forEach(function (set) {
        Object.keys(set).forEach(function (key) { if (keys.indexOf(key) === -1) keys.push(key); });
      });
      var directions = {};
      DERIVED.forEach(function (rule) { if (rule.better) directions[rule.label] = rule.better; });
      keys.forEach(function (key) {
        rows.push({
          label: key,
          better: directions[key],
          values: sets.map(function (set) { return set[key] || ''; })
        });
      });

      rows.forEach(function (row) {
        var filled = row.values.filter(Boolean);
        var isDiff = filled.length > 1 && new Set(row.values.map(tidy)).size > 1;

        if (compact) {
          // Phones: the label gets its own full-width row above the values.
          var labelRow = document.createElement('tr');
          labelRow.className = 'dz-compare__label-row' + (isDiff ? ' is-diff' : '');
          var labelCell = document.createElement('th');
          labelCell.colSpan = products.length;
          labelCell.scope = 'colgroup';
          labelCell.textContent = row.label;
          labelRow.appendChild(labelCell);
          tableEl.appendChild(labelRow);
        }

        var tr = document.createElement('tr');
        if (isDiff) tr.className = 'is-diff';
        if (!compact) {
          var th = document.createElement('th');
          th.textContent = row.label;
          tr.appendChild(th);
        }

        var numbers = row.values.map(function (value) {
          var match = String(value).replace(/,/g, '').match(/-?\d+(\.\d+)?/);
          return match ? parseFloat(match[0]) : null;
        });
        var allNumeric = numbers.every(function (n) { return n !== null; });
        var best = -1;
        if (isDiff && allNumeric && row.better) {
          best = numbers.indexOf(row.better === 'low' ? Math.min.apply(null, numbers) : Math.max.apply(null, numbers));
        }

        row.values.forEach(function (value, index) {
          if (!value) tr.appendChild(cell('— לא צוין', 'dz-compare__missing'));
          else tr.appendChild(cell(value, index === best ? 'is-best' : ''));
        });
        tableEl.appendChild(tr);
      });

      loadingEl.hidden = true;
      root.hidden = false;
    }

    // Rotating a phone or resizing across the breakpoint switches layouts.
    var onBreakpoint = function () { if (shown) render(shown); };
    if (phone.addEventListener) phone.addEventListener('change', onBreakpoint);
    else if (phone.addListener) phone.addListener(onBreakpoint);

    var list = wanted();
    if (!list.length) {
      loadingEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }

    Promise.all(list.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) {
        loadingEl.hidden = true;
        emptyEl.hidden = false;
        return;
      }
      render(found);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["djzone-featured"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dz-tabs').forEach((tabs) => {
    const buttons = [...tabs.querySelectorAll('.dz-tab')];
    const activate = (button) => {
      buttons.forEach((b) => {
        const selected = b === button;
        b.setAttribute('aria-selected', String(selected));
        b.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
      button.focus();
    };
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          const dir = event.key === 'ArrowLeft' ? 1 : -1;
          activate(buttons[(index + dir + buttons.length) % buttons.length]);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["djzone-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.getElementById('dz-header');
    if (!header) return;

    var cartIcon = header.querySelector('.dz-native-actions cart-icon');
    var cartButton = cartIcon && cartIcon.closest('a, button');
    if (cartButton) cartButton.setAttribute('aria-label', 'עגלת קניות');

    var burger = header.querySelector('.dz-burger');
    var mobileMenu = header.querySelector('#dz-mobile-menu');
    if (burger && mobileMenu) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        mobileMenu.hidden = open;
      });
    }

    /* Horizon scrolls .page-wrapper instead of the window on wide screens,
       so the compact state listens to both. */
    var pageWrapper = document.querySelector('.page-wrapper');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var offset = Math.max(window.scrollY, pageWrapper ? pageWrapper.scrollTop : 0);
        header.classList.toggle('is-compact', offset > 80);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Mega menu. Pointer: opens on hover with a short intent delay so the menu
       does not flash when the cursor only crosses the bar; the link itself still
       navigates to the category page on click. Touch: the first tap opens the
       panel, the second follows the link. Keyboard: focus opens, Escape closes. */
    var items = Array.prototype.slice.call(header.querySelectorAll('.dz-nav-item.has-mega'));
    var openTimer = null;
    var closeTimer = null;

    function setOpen(item, open) {
      item.classList.toggle('is-open', open);
      var top = item.querySelector('.dz-nav-top');
      if (top) top.setAttribute('aria-expanded', String(open));
    }
    function closeAll(except) {
      items.forEach(function (item) { if (item !== except) setOpen(item, false); });
    }

    items.forEach(function (item) {
      var top = item.querySelector('.dz-nav-top');

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType === 'touch') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        var anyOpen = items.some(function (other) { return other.classList.contains('is-open'); });
        openTimer = setTimeout(function () { closeAll(item); setOpen(item, true); }, anyOpen ? 0 : 110);
      });
      item.addEventListener('pointerleave', function (event) {
        if (event.pointerType === 'touch') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { setOpen(item, false); }, 160);
      });

      top.addEventListener('click', function (event) {
        var coarse = window.matchMedia('(hover: none)').matches;
        if (coarse && !item.classList.contains('is-open')) {
          event.preventDefault();
          closeAll(item);
          setOpen(item, true);
        }
      });

      item.addEventListener('focusin', function () { closeAll(item); setOpen(item, true); });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) closeAll();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = items.filter(function (item) { return item.classList.contains('is-open'); })[0];
      closeAll();
      if (open) open.querySelector('.dz-nav-top').focus();
      if (burger && mobileMenu && !mobileMenu.hidden) {
        mobileMenu.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
        burger.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["djzone-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initSlider(root) {
      if (root.dzSlider) return;
      const slides = [...root.querySelectorAll('.dz-hs-slide')];
      if (slides.length < 2) return;
      const dots = [...root.querySelectorAll('.dz-hs-dot')];
      const toggle = root.querySelector('.dz-hs-toggle');
      const track = root.querySelector('.dz-hs-track');
      const delay = Number(root.dataset.interval) || 6000;
      const state = { index: 0, timer: 0, paused: root.dataset.autoplay !== 'true' || reducedMotion.matches, hover: false, focus: false };
      root.dzSlider = state;

      const running = () => !state.paused && !state.hover && !state.focus && !document.hidden;
      const schedule = () => {
        clearTimeout(state.timer);
        if (running()) state.timer = setTimeout(() => go(state.index + 1), delay);
      };
      const go = (target) => {
        state.index = (target + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === state.index;
          slide.classList.toggle('is-active', active);
          slide.inert = !active;
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        dots.forEach((dot, i) => {
          if (i === state.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        schedule();
      };
      const syncToggle = () => {
        root.classList.toggle('is-paused', state.paused);
        if (toggle) toggle.setAttribute('aria-label', state.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };

      root.querySelector('.dz-hs-next')?.addEventListener('click', () => go(state.index + 1));
      root.querySelector('.dz-hs-prev')?.addEventListener('click', () => go(state.index - 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      toggle?.addEventListener('click', () => {
        state.paused = !state.paused;
        syncToggle();
        schedule();
      });

      root.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') { state.hover = true; schedule(); }
      });
      root.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse') { state.hover = false; schedule(); }
      });
      root.addEventListener('focusin', () => { state.focus = true; schedule(); });
      root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget)) { state.focus = false; schedule(); }
      });
      document.addEventListener('visibilitychange', schedule);

      // Arrow keys on the controls; in RTL the next slide is to the left.
      root.addEventListener('keydown', (event) => {
        if (!event.target.closest('.dz-hs-arrow, .dz-hs-dots')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          go(state.index + (event.key === 'ArrowLeft' ? 1 : -1));
        }
      });

      let startX = null;
      let startY = 0;
      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
        startY = event.clientY;
      });
      track.addEventListener('pointerup', (event) => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.2) go(state.index + (dx > 0 ? 1 : -1));
      });
      track.addEventListener('pointercancel', () => { startX = null; });

      // Theme editor: selecting a slide in the sidebar shows it and stops the rotation.
      root.addEventListener('shopify:block:select', (event) => {
        const i = slides.indexOf(event.target);
        if (i > -1) {
          state.paused = true;
          syncToggle();
          go(i);
        }
      });

      syncToggle();
      schedule();
    }

    const initAll = (scope) => scope.querySelectorAll('[data-dz-slider]').forEach(initSlider);
    initAll(document);
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
